



































import Vue, { PropType } from "vue";
import MessageView, { MessageViewParam } from "@/components/MessageView.vue";
import { messages } from "@/ts/const/Messages";
import { Loadable } from "@/ts/Loadable";
import { EECurriculum } from "@/ts/objects/curriculum/value/EECurriculum";
import { EECJournalTree } from "@/ts/objects/curriculum/value/EECJournal";
import CurriculumReadMainHeader from "@/views/curriculum/student/components/CurriculumReadMainHeader/CurriculumReadMainHeader.vue";
import CurriculumJournalRow from "@/views/curriculum/components/CurriculumJournalRow/CurriculumJournalRow.vue";
import LoadingBlock from "@/components/loading/LoadingBlock.vue";
import CurriculumJournalHeaderRow from "@/views/curriculum/components/CurriculumJournalHeaderRow/CurriculumJournalHeaderRow.vue";
import { isNullish } from "@/ts/utils";

export default Vue.extend({
  name: "CurriculumReadEECPure",
  components: { CurriculumJournalRow, CurriculumJournalHeaderRow, MessageView, LoadingBlock, CurriculumReadMainHeader },
  props: {
    /**
     * 児童生徒ID。
     */
    studentUserId: { type: String as PropType<string | null | undefined> },

    /**
     * 文書評価教科。
     */
    eeCurriculum: { type: Object as PropType<Loadable<EECurriculum | null>>, required: true },

    /**
     * 現在表示中の教科・児童生徒配下の学習記録。
     */
    journalTrees: { type: Object as PropType<Loadable<EECJournalTree[]>>, required: true },

    /**
     * 現在ファイルビューを開いている学習記録のリソース名。
     */
    filesViewJournal: { type: String as PropType<string | null> },

    /**
     * 現在ファイルビューを開いている学習記録を変更する関数。
     */
    selectFilesViewJournal: { type: Function as PropType<(rname: string | null) => void>, required: true },
  },
  data(): {
    months: number[];
    monthColWidth: number;
    extraMenuColWidth: number;
    otherColMinWidth: number;
  } {
    return {
      months: [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3],
      monthColWidth: 71,
      extraMenuColWidth: 20,
      otherColMinWidth: 110,
    };
  },
  computed: {
    messageView(): MessageViewParam | null {
      if (isNullish(this.studentUserId)) return { message: messages.shouldSelectStudent };
      if (this.eeCurriculum.isError || this.journalTrees.isError) return { message: messages.failedToLoadData };
      return null;
    },
    styles(): Record<string, string> {
      return {
        "--monthColWidth": `${this.monthColWidth}px`,
        "--extraMenuColWidth": `${this.extraMenuColWidth}px`,
        "--otherColMinWidth": `${this.otherColMinWidth}px`,
      };
    },
  },
});
